// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input[type="file"] {
    display: none;
}

.custom-file-upload {
    padding: 0;
    min-width: 0;
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    line-height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    text-align: center;
    align-content: center;
    flex-direction: column;
}

.file-upload {
    margin-top: 8px;
}

.previewIcon {
    width: 40px;
    height: 40px;
    align-self: center;
    border: 1px solid #D5D5D5;
    border-radius: 3px;
    margin-right: 5px;
    justify-content: center;
}

.previewIconContent {
    background-position: center;
    background-repeat: no-repeat;
    align-self: center;
    width: 100%;
    height: 100%;
}

.alignIcons {
    align-content: flex-start;
}

.iconDIV {
    /*width: 60px;
    height: 60px;*/
    margin: 4px;
    overflow: hidden;
}

    .iconDIV:hover {
        background-color: grey;
    }

    .iconDIV.selectedIcon {
        background-color: var(--primary-color);
    }

        .iconDIV.selectedIcon:hover {
            background-color: var(--primary-color);
        }
`, "",{"version":3,"sources":["webpack://./src/app/settings/ci/fonts/font.settings.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;kBACc;IACd,WAAW;IACX,gBAAgB;AACpB;;IAEI;QACI,sBAAsB;IAC1B;;IAEA;QACI,sCAAsC;IAC1C;;QAEI;YACI,sCAAsC;QAC1C","sourcesContent":["input[type=\"file\"] {\n    display: none;\n}\n\n.custom-file-upload {\n    padding: 0;\n    min-width: 0;\n    width: 40px;\n    height: 40px;\n    flex-shrink: 0;\n    line-height: 40px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    text-align: center;\n    align-content: center;\n    flex-direction: column;\n}\n\n.file-upload {\n    margin-top: 8px;\n}\n\n.previewIcon {\n    width: 40px;\n    height: 40px;\n    align-self: center;\n    border: 1px solid #D5D5D5;\n    border-radius: 3px;\n    margin-right: 5px;\n    justify-content: center;\n}\n\n.previewIconContent {\n    background-position: center;\n    background-repeat: no-repeat;\n    align-self: center;\n    width: 100%;\n    height: 100%;\n}\n\n.alignIcons {\n    align-content: flex-start;\n}\n\n.iconDIV {\n    /*width: 60px;\n    height: 60px;*/\n    margin: 4px;\n    overflow: hidden;\n}\n\n    .iconDIV:hover {\n        background-color: grey;\n    }\n\n    .iconDIV.selectedIcon {\n        background-color: var(--primary-color);\n    }\n\n        .iconDIV.selectedIcon:hover {\n            background-color: var(--primary-color);\n        }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
